import { Box, useTheme } from '@mui/material'
import icons from '../assets/icons'
import StyledIcon from './StyledIcon'
import { iconSizes } from './RectButton'
import { BaseColor, iconColors, MaterialColor, spacingToNumber } from '../theme/default'

const customColors = ['peach', 'blue', 'purple', 'red', 'green', 'orange', 'gray'] as const
type CustomColor = typeof customColors[number]

interface Props {
  icon8?: keyof typeof icons
  iconSrc?: string | undefined
  size?: keyof typeof iconSizes
  color?: BaseColor | CustomColor
}

const colorsFromProps = (color: Props['color']) => {
  if (customColors.includes(color as any)) {
    return {
      backgroundColor: iconColors[`${color}Color` as keyof typeof iconColors],
      iconColor: 'primary.contrastText' as MaterialColor,
    }
  }
  return {
    backgroundColor: `${color}.main`,
    iconColor: `${color}.contrastText` as MaterialColor,
  }
}

const CircleIcon = (props: Props) => {
  const { icon8, size = 'medium', iconSrc } = props
  const theme = useTheme()
  const colors = colorsFromProps(props.color ?? 'primary')

  let padding = 1.5

  if (size === 'tiny' || size === 'nano') {
    padding = 1
  }

  const containerSize = iconSizes[size] + spacingToNumber(theme.spacing(padding))

  if (iconSrc && props.color) {
    console.warn('The color prop will not tint the iconSrc image')
  }

  return <Box sx={{
    borderRadius: '50%',
    minWidth: 0,
    width: containerSize,
    height: containerSize,
    display: 'flex',
    backgroundColor: colors.backgroundColor,
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
  }}>
    {!!icon8 && <StyledIcon
      name={icon8}
      size={iconSizes[size]}
      color={colors.iconColor}
    />}
    {!icon8 && !!iconSrc && <Box
      component='img'
      src={iconSrc}
      sx={{
        height: iconSizes[size],
        width: 'auto',
      }}
    />}
  </Box>
}

export default CircleIcon
